import React, {Component} from 'react';
import {LayoutSidebar} from '../../../../Layout';
import {withRouterParams} from '../../../../utils/withRouterParams';
import {BoosterFlowContent} from './BoosterFlowContent';

/**
 * El Recorrido del AI Booster como UNA página. Ruta `/client/:id/booster`, con los actos como
 * anclas (`#alimenta`, `#revisa`, `#memoria`, `#usa`).
 *
 * Las rutas viejas (`/memory/*`, `/ia`) siguen vivas y redirigen acá con el ancla que corresponde:
 * son links que están en producción —el badge de la cola, los CTAs del Panel, la campanita, el
 * Command Center— y ninguno puede morir.
 */
export class ClientBoosterPage extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <BoosterFlowContent clientId={this.props.match.params.id}/>
            </div>
        );
    }
}

export default withRouterParams(ClientBoosterPage);
